<template>
  <div id="marquee" style="background-color:white;">
    <img :src="isamnet" style="width:100%" @load="onLoad" />
    <img :src="isamnet" style="width:100%" />
    <div
      class="ucmarquee-wrapper"
      :style="
        creative.offset_bottom_number
          ? `bottom:${creative.offset_bottom_number}${
              creative.offset_bottom_unit
            }`
          : ``
      "
    >
      <a v-if="creative.closeBtnType==0" class="closebutton" @click="close()"></a>
      <div v-if="creative.closeBtnType==1" class="closebutton"
        :style="{
          position: `absolute`,
          display: `block`,
          width: `14px`,
          height: `14px`,
          zIndex: `50000`,
          bottom: `130px`,
          backgroundSize: `contain`,
          borderRadius: `16px`,
          top: `${top}px`,
          right: `${right}px`,
          backgroundColor: `transparent`,
          backgroundImage: `none`,
      }"
        ><svg width="14" height="14" style="border: 0px solid black;position:absolute;"><circle cx="7" cy="7" r="6" fill="gray" fill-opacity="0.3" stroke="black" stroke-width="0"></circle><line x1="3" y1="3" x2="11" y2="11" stroke="black" stroke-width="1.5"></line><line x1="3" y1="11" x2="11" y2="3" stroke="black" stroke-width="1.5"></line></svg>
        <a @click="close()"
          :style="{
            position: `absolute`,
            display: `block`,
            width: `11px`,
            height: `11px`,
            zIndex: `50000`,
            bottom: `130px`,
            backgroundSize: `contain`,
            borderRadius: `16px`,
            top: `1.5px`,
            right: `1.5px`,
            backgroundColor: `transparent`,
            backgroundImage: `none`,
          }"
        ></a>
      </div>
      <div
        class="ucmarquee-container"
        :style="{
          width: creative.images.length * 100 + 'vw',
        }"
      >
        <a :href="creative.landing_page" target="_blank">
          <img
            v-for="(img, index) in creativeImages"
            :ref="'item-' + index"
            :key="index"
            :src="img.url"
            @load="onLoad"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import mixPreview from '@/components/mixins/preview.js';
import mixMobile from '@/components/mixins/mobile.js';
export default {
  data() {
    return {
      imgWidth: (this.creative.width) ? this.creative.width : 320,
      imgHeight: (this.creative.height) ? this.creative.height : 100,
      top: 12,
      right: 9,
      baseSpeed: 50,
      scrollSpeedFactor: 1,
      lastScrollY: window.scrollY,
      interval: null,
      creativeImages: (this.creative.marqueeType != CONSTANT.MARQUEE_TYPE.STOP) ? [...this.creative.images, ...this.creative.images] : [...this.creative.images, ...this.creative.images, ...this.creative.images, ...this.creative.images, ...this.creative.images, ...this.creative.images],
      imageElms: [],
      stopMarquee: false,
      positions: [],
    };
  },
  computed: {
    isamnet() {
      let domain = window.location.hostname;
      let isAmnet = 'https://cdn.aralego.net/rich_media/assets';
      if (domain === 'prism.amnet.tw') {
        isAmnet += '/amnet/bg3.png';
      } else {
        isAmnet += '/marquee/bg.png';
      }
      return isAmnet;
    },
  },
  methods: {
    resetPosition(index, position, len) {
      const vh = window.parent.innerHeight || window.parent.document.documentElement.clientHeight || window.parent.document.body.clientHeight;
      const vw = window.parent.innerWidth || window.parent.document.documentElement.clientWidth || window.parent.document.body.clientWidth;
      const height = Math.min(vh / 4, (vw * this.imgHeight) / this.imgWidth);
      const width = this.imgWidth / this.imgHeight * height;
      let min = -width * (index + 1);
      let max = width * (len - index - 1);
      if (position <= min) {
        position += width * len;
      } else if (position >= max) {
        position -= width * len;
      }
      return position;
    },
    animateMarquee() {
      let positions = this.positions;
      let baseSpeed = this.baseSpeed;
      let scrollSpeedFactor = this.scrollSpeedFactor;
      let resetPosition = this.resetPosition;
      if (!this.stopMarquee) {
        this.imageElms.forEach(function(element, index, array) {
          positions[index] -= (baseSpeed * scrollSpeedFactor) / 60;
          positions[index] = resetPosition(index, positions[index], positions.length);
          element.style.transform = `translateX(${positions[index]}px)`;
        });
      }
      requestAnimationFrame(this.animateMarquee);
    },
    handleScroll() {
      let currentScrollY = window.scrollY;
      let deltaY = currentScrollY - this.lastScrollY;
      this.scrollSpeedFactor = 1 + Math.min(Math.abs(deltaY) / 100, 1)*20;
      if (deltaY < 0) {
        this.scrollSpeedFactor = -this.scrollSpeedFactor;
      }
      this.lastScrollY = currentScrollY;
    },
    checkScrolling() {
      if (this.lastScrollY ==  window.scrollY) {
        this.scrollSpeedFactor = 1;
      }
    },
    handleResize() {

    }
  },
  mixins: [mixPreview, mixMobile],
  mounted() {
    this.viewport();
    const wrapper = document.querySelector('.ucmarquee-wrapper');
    const vh =
      window.parent.innerHeight ||
      window.parent.document.documentElement.clientHeight ||
      window.parent.document.body.clientHeight;
    const vw =
      window.parent.innerWidth ||
      window.parent.document.documentElement.clientWidth ||
      window.parent.document.body.clientWidth;
    const height = Math.min(vh / 4, (vw * this.imgHeight) / this.imgWidth);
    const width = this.imgWidth / this.imgHeight * height;
    this.setStyle(wrapper, { height: height + 'px' });

    this.addEvent(window.parent, 'resize', () => {
      const vh =
        window.parent.innerHeight ||
        window.parent.document.documentElement.clientHeight ||
        window.parent.document.body.clientHeight;
      const vw =
        window.parent.innerWidth ||
        window.parent.document.documentElement.clientWidth ||
        window.parent.document.body.clientWidth;
      const height = Math.min(vh / 4, (vw * this.imgHeight) / this.imgWidth);
      const width = this.imgWidth / this.imgHeight * height;
      this.setStyle(wrapper, { height: height + 'px' });
      this.stopMarquee = true;
      let positions = this.positions;
      this.imageElms.forEach(function(element, index, array) {
        positions[index] = 0;
        element.style.cssText = `width: ${width}px;height: ${height}px;transform: translateX(0px);`;
      });
      this.stopMarquee = false;
    });

    window.visualViewport.addEventListener("resize", () => {
      const vh =
        window.parent.innerHeight ||
        window.parent.document.documentElement.clientHeight ||
        window.parent.document.body.clientHeight;
      const vw =
        window.parent.innerWidth ||
        window.parent.document.documentElement.clientWidth ||
        window.parent.document.body.clientWidth;
      const height = Math.min(vh / 4, (vw * this.imgHeight) / this.imgWidth);
      const width = this.imgWidth / this.imgHeight * height;
      this.setStyle(wrapper, { height: height + 'px' });
      this.stopMarquee = true;
      let positions = this.positions;
      this.imageElms.forEach(function(element, index, array) {
        positions[index] = 0;
        element.style.cssText = `width: ${width}px;height: ${height}px;transform: translateX(0px);`;
      });
      this.stopMarquee = false;
    });

    for (let i = 0; i < this.creativeImages.length ; i++) {
      let key = 'item-' + i;
      this.imageElms.push(this.$refs[key][0])
      this.positions.push(0);
    }
    if (this.creative.marqueeType != CONSTANT.MARQUEE_TYPE.STOP) {
      this.animateMarquee();
    }
    if (this.creative.marqueeType == CONSTANT.MARQUEE_TYPE.SPEED_CHANGE) {
      this.interval = setInterval(this.checkScrolling, 500);
      window.addEventListener('scroll', this.handleScroll)
    }
  },
  beforeDestroy() {
    if (this.creative.marqueeType == CONSTANT.MARQUEE_TYPE.SPEED_CHANGE) {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
      window.removeEventListener('scroll', this.handleScroll)
    }
  }
};
</script>

<style lang="sass">
.ucmarquee-wrapper
  position: fixed
  width: 100vw
  bottom: 0px
  left: 0px
  overflow: hidden
  .closebutton
    cursor: pointer
    position: absolute
    display: block
    width: 24px
    height: 24px
    background-color: white
    background-position: 0 0
    background-image: url('https://cdn.aralego.net/rich_media/assets/close_btn.png')
    z-index: 50000
    top: 5px
    right: 5px
    background-size: contain
    border-radius: 16px
  .ucmarquee-container
    height: 100%
    a
      display: inline-flex
      height: 100%
      img
        width: 100vw

@include keyframes(marquee)
  0%
    transform: translateX(0%)
  100%
    transform: translateX(-100%)
</style>
